import {
  HEAP_EVENTS,
  ResultDocumentsInfo,
  TestDetailsRecord,
} from "@app/provider/types";
import { getTestNameForHeapByTestType } from "./getTestNameForHeap";
import { businessUnitMapper } from "./businessUnitMapper";
import { getDrawCoordinatorForHeap } from "./getDrawCoordinatorForHeap";
import { isFirstResultView } from "./isFirstResultView";

enum Occurrence {
  firstTime = "first_time",
  repeat = "repeat",
}

type GetPdfViewHeapHandlers = (
  testDetails?: TestDetailsRecord,
  orderUidPublic?: string,
  testDocumentUid?: string
) => {
  onPdfViewErrorHeap: () => void;
  onPdfViewSuccessHeap: () => void;
};

const getLimsDocumentId = (
  testDocumentUid?: string,
  resultDocumentsInfo?: ResultDocumentsInfo[]
) => {
  if (!testDocumentUid) {
    return undefined;
  }
  return resultDocumentsInfo?.find((doc) => doc.documentUid === testDocumentUid)
    ?.documentReferenceId;
};

const buildPdfViewHeapPayload = (
  testDetails?: TestDetailsRecord,
  orderUidPublic?: string,
  testDocumentUid?: string
) => {
  if (!testDetails) {
    return orderUidPublic ? { public_order_uid: orderUidPublic } : {};
  }

  return {
    test_name: getTestNameForHeapByTestType(testDetails.testType),
    lims_clinic_id: testDetails.clinic?.limsId,
    public_order_uid: testDetails.orderUidPublic,
    occurrence: isFirstResultView(testDetails)
      ? Occurrence.firstTime
      : Occurrence.repeat,
    business_unit: businessUnitMapper(testDetails.businessUnit),
    draw_coordinator: getDrawCoordinatorForHeap({
      businessUnit: businessUnitMapper(testDetails.businessUnit),
      managedBy: testDetails.managedBy,
    }),
    lims_document_id: getLimsDocumentId(
      testDocumentUid,
      testDetails.resultDocumentsInfo
    ),
  };
};

export const getPdfViewHeapHandlers: GetPdfViewHeapHandlers = (
  testDetails,
  orderUidPublic,
  testDocumentUid
) => {
  const onPdfViewErrorHeap = () => {
    heap.track(
      HEAP_EVENTS.upp_viewresultpdf_failure,
      buildPdfViewHeapPayload(testDetails, orderUidPublic, testDocumentUid)
    );
  };

  const onPdfViewSuccessHeap = () => {
    if (testDetails) {
      heap.track(
        HEAP_EVENTS.upp_viewresultpdf_success,
        buildPdfViewHeapPayload(testDetails, orderUidPublic, testDocumentUid)
      );
    }
  };

  return {
    onPdfViewErrorHeap,
    onPdfViewSuccessHeap,
  };
};
